import React, { useContext, useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import Footer from '../../components/Global/Footer/Footer';
import Header from '../../components/PlacePage/Header/Header';
import Description from '../../components/Global/Description/Description';
import { Trail } from '../../models/Trail';
import Map from '../../components/TrailPage/Map/Map';
import Actions from '../../components/TrailPage/Actions/Actions';
import Waypoints from '../../components/TrailPage/Waypoints/Waypoints';
// import ExploreMore from '../../components/TrailPage/ExploreMore/ExploreMore';
import VirtualTour from '../../components/TrailPage/VirtualTour/VirtualTour';
import Navigate from '../../components/TrailPage/Navigate/Navigate';
import FeaturedVideo from '../../components/Global/FeaturedVideo/FeaturedVideo';
import { TrailHelper } from '../../models/helpers/Helpers';
import { ExplorerContext } from '../../application/config';
import { useParams, useHistory } from 'react-router';
import { TrailFactory, TrailQuery } from '../../models/factories/TrailFactory';
import TrailTopNav from '../../components/Global/InnerPageComponents/TrailTopNav';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../state/hooks';
import { selectPrefs } from '../../state/selectors';
import ExternalUrl from '../../components/Global/ExternalUrl/ExternalUrl';

type TrailPageProps = {
	//trail: Trail;
};

const TrailPage: React.FC<TrailPageProps> = () => {
	const history = useHistory();
	const AppData = useContext(ExplorerContext);
	const { trailId } = useParams<{ trailId: string }>();
	const [ActiveTrail, SetActiveTrail] = useState<Trail | undefined>(
		undefined,
	);
	const [isVTOpen, setIsVTOpen] = useState(false);
	const [isNavOpen, setIsNavOpen] = useState(false);
	const userPrefs = useAppSelector(selectPrefs, shallowEqual);

	useEffect(() => {
		if (trailId) {
			const filterQuery: TrailQuery = {
				filter: { id: [Number(trailId)] },
			};
			const selectedTrailList = TrailFactory.filter(
				AppData.features?.all_trails ?? TrailFactory.getEmpty(),
				filterQuery,
			);
			if (selectedTrailList.trails.length > 0) {
				SetActiveTrail(selectedTrailList.trails[0]);
			} else {
				SetActiveTrail(undefined);
			}
		} else {
			SetActiveTrail(undefined);
		}
	}, [trailId, AppData.features?.all_trails]);

	if (ActiveTrail) {
		return (
			<IonPage>
				<IonContent fullscreen>
					{ActiveTrail.id && <TrailTopNav trailId={ActiveTrail.id} />}
					<Header
						title={ActiveTrail.title}
						image={ActiveTrail.image}
						metaString={TrailHelper.generateMetaString(
							ActiveTrail,
							userPrefs.preferred_dist_units ?? 'km',
						)}
						difficultyString={ActiveTrail.difficulty_label}
						activities={ActiveTrail.activities}
					/>
					<Actions
						setIsVTOpen={setIsVTOpen}
						setIsNavOpen={setIsNavOpen}
						trail={ActiveTrail}
					/>
					<main>
						<Description text={ActiveTrail.description} />
						{ActiveTrail.featured_video && (
							<FeaturedVideo src={ActiveTrail.featured_video} />
						)}
						<Map
							trail={ActiveTrail}
							setIsVTOpen={setIsVTOpen}
							setIsNavOpen={setIsNavOpen}
						/>
						{/* TODO: Replace with a Trail specific map */}
						{ActiveTrail.waypoints.length > 0 && (
							<Waypoints points={ActiveTrail.waypoints} />
						)}
						{/* <ExploreMore /> */}
						{ActiveTrail.url && (
							<ExternalUrl
								url={ActiveTrail.url}
								description={
									ActiveTrail.external_url_description
								}
							/>
						)}
					</main>
					<Footer />
					<VirtualTour
						isOpen={isVTOpen}
						setIsOpen={setIsVTOpen}
						trail={ActiveTrail}
					/>
					<Navigate
						isOpen={isNavOpen}
						setIsOpen={setIsNavOpen}
						trail={ActiveTrail}
					/>
				</IonContent>
			</IonPage>
		);
	} else {
		return (
			<IonPage>
				<IonContent fullscreen>
					<main style={{ padding: '2rem', textAlign: 'center' }}>
						<h2>Trail not found</h2>
						<p>This trail may have been removed or is no longer available.</p>
						<button onClick={() => history.replace('/home')}>Go Home</button>
					</main>
				</IonContent>
			</IonPage>
		);
	}
};

export default TrailPage;
